<div mat-dialog-title>
  <h2>{{"content3.zatca config" | translate}}</h2>
  <button mat-icon-button (click)="openConfirmDialog()" class="close" aria-label="Close">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup">
  <mat-dialog-content>
    <div class="mat-dialog-body">

      <mat-form-field class="form-group" hideRequiredMarker>
        <mat-label>{{ 'content3.Registeration Type' | translate }}</mat-label>
        <mat-select formControlName="registerationType">
          <mat-option [value]="1">{{'content3.Simplified' | translate}}</mat-option>
          <mat-option [value]="2">{{'content3.Standard & Simplified' | translate}}</mat-option>
        </mat-select>
        <mat-error *ngIf="hasError('registerationType', 'required')">
          {{ 'forms.Required' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="form-group" hideRequiredMarker>
        <mat-label>{{ 'content3.Mode' | translate }}</mat-label>
        <mat-select formControlName="mode">
          <mat-option [value]="1">{{'content3.Sign' | translate}}</mat-option>
          <mat-option [value]="2">{{'content3.Sign & Send' | translate}}</mat-option>
        </mat-select>
        <mat-error *ngIf="hasError('mode', 'required')">
          {{ 'forms.Required' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="form-group" hideRequiredMarker>
        <mat-label>{{"content3.Seller Name" | translate}}</mat-label>
        <input matInput formControlName="sellerName" maxlength="20">
        <mat-error *ngIf="hasError('sellerName', 'required')">{{ 'forms.Required' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field class="form-group" hideRequiredMarker>
        <mat-label>{{"content3.OTP" | translate}}</mat-label>
        <input matInput formControlName="otp" maxlength="20">
        <mat-error *ngIf="hasError('otp', 'required')">{{ 'forms.Required' | translate }}</mat-error>
      </mat-form-field>


      <div class="grey-list-items mb-3">
        <div class="list-item border border-raduis">
          <div class="d-flex align-items-center">
            <p class="font-weight-normal">
              {{"content3.Production" | translate}}</p>
          </div>
          <div>
            <mat-slide-toggle formControlName="isProduction"></mat-slide-toggle>
          </div>
        </div>
      </div>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button type="button" (click)="openConfirmDialog()" class="btn-grey">
      {{"forms.Cancel" | translate}}
    </button>
    <button mat-raised-button color="primary" (click)="saveRecord()" [disabled]="loading" [class.loading]="loading">
      {{"forms.Save" | translate}}
    </button>
  </mat-dialog-actions>
</form>
